import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import styles from "./whatsapp.module.scss";

const CATEGORY_LABELS_RU = {
  accrual: "Начисление",
  withdraw: "Списание",
  transaction: "Транзакция",
  expiry: "Сгорание бонусов",
  expired: "Бонусы сгорели",
  otp: "Код подтверждения",
  campaign: "Рассылка",
  bonus: "Бонусы",
  birthday: "День рождения",
  default: "По умолчанию",
};

const BrandedChannelExpanded = ({ channel, info, liveTemplates = [], onDisconnect }) => {
  const { t } = useTranslation();
  const [openKey, setOpenKey] = useState(null);
  const wp = info?.configuration?.whatsapp_provider || {};
  const templates = wp.waba_templates || {};
  const bodyByName = {};
  const liveNames = new Set();
  (liveTemplates || []).forEach((tpl) => {
    if (tpl?.name) {
      bodyByName[tpl.name] = tpl.body || "";
      liveNames.add(tpl.name);
    }
  });
  const templateRows = Object.entries(templates).filter(([, v]) => !!v);
  return (
    <section className={styles.brandedExpanded}>
      <div className={styles.brandedExpandedHeader}>
        <h2>{channel?.display_name || t("NSWhatsapp.channelBranded")}</h2>
        <span className={styles.channelBadge_connected}>
          {t("NSWhatsapp.channelConnected")}
        </span>
      </div>
      <dl className={styles.channelMeta}>
        {channel?.phone && (
          <>
            <dt>{t("NSWhatsapp.phoneNumber")}</dt>
            <dd>{channel.phone}</dd>
          </>
        )}
        {channel?.display_handle && (
          <>
            <dt>{t("NSWhatsapp.displayName")}</dt>
            <dd>{channel.display_handle}</dd>
          </>
        )}
      </dl>
      {templateRows.length > 0 && (
        <div className={styles.templatesAccordion}>
          <h3>{t("NSWhatsapp.brandedTemplatesHeader")}</h3>
          {templateRows.map(([key, name]) => {
            const isOpen = openKey === key;
            const body = bodyByName[name];
            return (
              <div key={key} className={styles.tplItem}>
                <button
                  type="button"
                  className={styles.tplHeader}
                  onClick={() => setOpenKey(isOpen ? null : key)}
                >
                  <span>{CATEGORY_LABELS_RU[key] || key}</span>
                  <span className={styles.tplChevron}>{isOpen ? "▾" : "▸"}</span>
                </button>
                {isOpen && (
                  <div className={styles.tplPanel}>
                    {body ? (
                      body
                    ) : liveNames.has(name) ? (
                      <span className={styles.tplEmpty}>
                        {`${name} — текст недоступен для предпросмотра (шаблон авторизации Meta).`}
                      </span>
                    ) : (
                      <span className={styles.tplEmpty}>
                        {`${name} — шаблон не найден на канале WABA (устаревшая настройка).`}
                      </span>
                    )}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
      {onDisconnect && (
        <button
          type="button"
          className={styles.channelDisconnect}
          onClick={onDisconnect}
        >
          {t("NSWhatsapp.channelDisconnect")}
        </button>
      )}
    </section>
  );
};

export default BrandedChannelExpanded;
